import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { hideLoader, showLoader } from '../../../api/loader/loaderSlice';
import { analyticsClient } from '../../../utils/axios';

export const fetchMisFilterOptions = async () => {
  const { data } = await analyticsClient.get('/v1/mis/filter-options', { skipErrorSnackbar: true });
  return data;
};

export const useGetMisFilterOptionsHandler = ({ enabled = true } = {}) => {
  const dispatch = useDispatch();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['mis-filter-options'],
    queryFn: async () => {
      dispatch(showLoader());
      try {
        return await fetchMisFilterOptions();
      } finally {
        dispatch(hideLoader());
      }
    },
    enabled,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 5 * 60 * 1000,
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || error.message,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: JSON.stringify(error),
            severity: 'error',
          }),
        );
      }
    }
  }, [dispatch, error, isError]);

  return {
    filterOptions: data,
    isLoading,
  };
};
